<template>
  <div>
    

    <b-row>
      <b-col md="6">
        <h4 class="font-weight-bold ml-1">Fakturering</h4>
      </b-col>

      <b-col md="2">
        <div class="float-right">
          <label class="nav-item navbar-text navbar-search-box p-0 active">
            <i class="ion ion-ios-search navbar-icon align-middle"></i>
            <span class="navbar-search-input pl-2">
              <b-form-input class="ml-2" v-model="filter" placeholder="Søk"></b-form-input>
            </span>
          </label>
        </div>
      </b-col>

      <b-col md="2">

        <!-- <b-form-checkbox class="mt-2 float-left" v-model="showAllOrders" v-on:change="updateOrders()">
          Vis fakturert
        </b-form-checkbox> -->
      </b-col>


      <b-col md="2">
        <!-- <b-button class="float-right mr-2" variant="primary" v-b-modal.newOrder @click="openModal()">Opprett ny ordre
        </b-button> -->
      </b-col>
    </b-row>

    <!-- / User Interface controls -->

    <!-- Main table element -->

    <div>
      <b-table show-empty caption-top stacked="sm" :items="orders" :fields="fields" :current-page="currentPage"
        :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-direction="sortDirection" :hover="hoverTable"
        empty-text="There are no orders to show">

        <!-- @row-clicked="(item) => $set(item, '_showDetails', !item._showDetails)" -->

        <template v-slot:table-caption>
          <b-row>
            <b-col md="2">
              <span> Totalt: {{ orders.length | numeralFormat }} ordrer</span>
            </b-col>

            <b-col md="1">


            </b-col>

            <b-col md="10">

            </b-col>
          </b-row>

        </template>

        <template v-slot:cell(status)="data">
          <b-badge pill v-if="data.item.status == 'Bestilling'" variant="secondary">{{ data.item.status }} </b-badge>
          <b-badge pill v-if="data.item.status == 'Ordre'" variant="primary">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'I arbeid'" variant="dark">{{ data.item.status }}  </b-badge>
          <b-badge pill v-if="data.item.status == 'Arbeid avsluttet'" variant="warning">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Til fakturering'" variant="info">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Fakturert'" variant="success">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Utført'" variant="success">{{ data.item.status }}</b-badge>
          <b-badge pill v-if="data.item.status == 'Kansellert'" variant="danger">{{ data.item.status }}</b-badge>
        </template>

        <template v-slot:cell(ordertitle)="data">
          <b-link class="link" :href="'#/dashboard/order-edit/' + data.item.id">
            <span v-if="data.item.customer_company != null">
              {{ data.item.ordernumber }} -
              {{ data.item.customer_company.name }}
              <span v-if="data.item.site != null">({{ data.item.site.name }})</span></span>
          </b-link>
        </template>

        <template v-slot:cell(vessel)="data">
          <span v-if="data.item.vessel != null">{{ data.value.name }}</span>
        </template>

        <template v-slot:cell(captain)="data">
          <span v-if="data.item.captain != null">{{ data.value }}</span>
        </template>

        <template v-slot:cell(duration)="data">
         <span v-if="data.item.startdate != data.item.enddate">
           
           {{ $date(data.item.startdate).format("DD.MM.YYYY") }} -
           {{ $date(data.item.enddate).format("DD.MM.YYYY") }}
          
          </span>

          <span v-if="data.item.startdate == data.item.enddate">
           
            {{ $date(data.item.startdate).format("DD.MM.YYYY") }} -
            {{ $date(data.item.enddate).format("DD.MM.YYYY") }} 
          
          </span>

        </template>

        <template v-slot:cell(days)="data">
         <span v-if="data.item.startdate != data.item.enddate">

           {{ $date(data.item.enddate).diff(data.item.startdate,"days") }}
          
          </span>

          <span v-if="data.item.startdate == data.item.enddate">
            1
          </span>

        </template>

        <template v-slot:cell(biomass)="data">
          <span v-if="data.item.type =='Avlusning'">
            {{ data.item.details.biomass_ordered | numeralFormat("0,0[.]00")}} kg 
          </span>

          <span v-if="data.item.type =='Brønnbåt'">
            {{ data.item.details.fishcount | numeralFormat("0,0[.]00")}} fisk 
          </span>
                                
        </template>

        <template v-slot:cell(fls)="data">
            {{ data.item.details.biomass_total | numeralFormat("0,0[.]00")}} kg                   
        </template>

        <template v-slot:cell(invoice_hours)="data">
            {{ data.value | numeralFormat("0,0[.]")}},-
        </template>


        <template v-slot:cell(invoice_biomass)="data">
            {{ data.value | numeralFormat("0,0[.]")}},-
        </template>


        <template v-slot:cell(invoice_total)="data">
            {{ data.value | numeralFormat("0,0[.]")}},-
        </template>


        <template v-slot:cell(createdAt)="data">
          <span v-if="data.item.createdAt != null">{{
            $date(data.value).format("DD.MM.YYYY")
          }}</span>
        </template>

        <template v-slot:cell(attachments)="data">
          <span v-if="data.item.attachments.length != 0"><i class="ion ion-ios-attach"></i></span>
        </template>


        <!-- <template #cell(actions)="row">
                  <b-button size="sm" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
        </b-button>

          <b-button variant="primary" class="mr-1 float-center" size="sm" @click="editOrder(row.item.id)">
            Rediger</b-button>
        </template> -->



        <!-- Order details in table -->

          <!-- <template #row-details="row">
            <b-card>
          
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        


            </b-card>
          </template> -->



      </b-table>

      <b-row>
        <b-col md="1" class="my-1">
          <b-form-group class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>

        <b-col md="2" class="my-1">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </div>


  </div>
</template>

<script>
  import axios from "axios";
  
  import Datepicker from "vuejs-datepicker";

  import { minBy, maxBy } from 'lodash'
  
  import VueMoment from "vue-moment";
  import moment from "moment";

  import {
    debounce
  } from "lodash";
  import _ from 'lodash'
  import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

  

  export default {
    components: {
      
      Datepicker,
      
      VueMoment,
      moment,
      VueTypeaheadBootstrap,
    },
    data() {
      return {
        user: {},
        order: {
          status: "Bestilling",
          type: "Avlusning",
          details: {
            cages: [],
          },
        },
        orders: [],
        company: {},
        newcompany: {},
        newconfirmation: false,
        site: "",
        sites: [],
        customers: [],
        showAllOrders: null,
        lastUpdate: {},
        fromDate: {},
        toDate: {},
        disabledDates: {},
        lookupCustomer: "",
        queryCustomer: "",
        queryCustomerNew: "",
        querySites: "",
        showNewCustomer: false,
        fields: [{
            key: "status",
            label: "Status",
            sortable: true
          },
          {
            key: "ordertitle",
            label: "Ordre",
            sortable: true,
            class: "text-left",
          },
          {
            key: "type",
            label: "Type",
            sortable: true
          },
          {
            key: "vessel",
            label: "Fartøy",
            sortable: true
          },
          {
            key: "duration",
            label: "Varighet",
            sortable: true
          },
          {
            key: "days",
            label: "Dager",
            sortable: true
          },
          {
            key: "biomass",
            label: "Bestilt",
            sortable: true
          },
          {
            key: "fls",
            label: "FLS",
            sortable: true
          },
          {
            key: "invoice_hours",
            label: "Arbeidstimer",
            sortable: true
          },
          {
            key: "invoice_biomass",
            label: "Tillegg",
            sortable: true
          },
          {
            key: "invoice_total",
            label: "Totalt",
            sortable: true
          },
          {
            key: "createdAt",
            label: "Opprettet",
            sortable: true
          },
          {
            key: "attachments",
            label: "",
          },
          {
            key: "actions",
            label: "",
          }
        ],
        orderType: [{
            value: "Avlusning",
            text: "Avlusning"
          },
          {
            value: "Notspyling",
            text: "Notspyling"
          },
          {
            value: "Servicearbeid",
            text: "Servicearbeid"
          },
          {
            value: "Brønnbåt",
            text: "Brønnbåt"
          },
        ],
        statusOptions: [{
            value: "Bestilling",
            text: "Bestilling"
          },
          {
            value: "Ordre",
            text: "Ordre"
          },
          {
            value: "I arbeid",
            text: "I arbeid"
          },
          {
            value: "Arbeid avsluttet",
            text: "Arbeid avsluttet"
          },
          {
            value: "Utført",
            text: "Utført"
          },
          {
            value: "Kansellert",
            text: "Kansellert"
          },
        ],
        vesselSelect: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 100,
        pageOptions: [25, 50, 100, 250, 500, 1000],
        sortBy: "created",
        sortDesc: true,
        sortDirection: "desc",
        filter: null,
        hoverTable: true,
        limit: 1000,
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        isLoading: false,
        fullPage: true,
      };
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter((f) => f.sortable)
          .map((f) => {
            return {
              text: f.label,
              value: f.key
            };
          });
      },
      sumOrdersTotal() {
        return this.orders.length;
      },
    },
    methods: {
      getUser() {
        axios.get("https://api.eines-as.no/users/me").then((res) => {
          this.user = res.data;
          this.company = res.data.company;
          this.order.ordernumber = res.data.company.ordernumber;
          this.order.supplier_company = res.data.company;

          
        });
      },
      async getOrders() {
        this.isLoading = true
        this.orders = []

        try {
          const company = localStorage.getItem("company")
          const res = await axios.get(
            `https://api.eines-as.no/orders?_limit=-1&_sort=ordernumber:DESC&status_eq=Til fakturering&status_eq=Fakturert&_where[supplier_company]=${company}`
          )
          this.orders = res.data
          this.totalRows = this.orders.length

          this.orders.forEach(order => {
            // collect all start / end worklog dates
            const worklogStart = []
            const worklogEnd   = []

            order.worklogs.forEach(worklog => {
              if (worklog.from && worklog.to !== worklog.from) {
                worklogStart.push({ date: worklog.from })
              }
              if (worklog.to   && worklog.to   !== worklog.from) {
                worklogEnd.push({ date: worklog.to })
              }
            })

            // sort and grab first/last safely
            const sortedStart = _.sortBy(worklogStart, ['date'])
            const sortedEnd   = _.sortBy(worklogEnd,   ['date']).reverse()

            // only assign if there *is* an entry
            if (sortedStart[0]?.date) {
              order.startdate = sortedStart[0].date
            }
            if (sortedEnd[0]?.date) {
              order.enddate = sortedEnd[0].date
            }
          })
        }
        catch (err) {
          console.error("Failed to load orders:", err)
        }
        finally {
          this.isLoading = false
        }
      },
      updateOrder(order) {
        this.isLoading = true;

        // Send order confirmation

        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;

          var message = {
            to: this.order.contact_email1, 
            subject: 'Ordrebekreftelse fra ' + this.order.supplier_company.name,
            template: '60462ff735f1aa48189844e4',
            details: {
              order: this.order,
              ordernumber: this.order.ordernumber,
              ordertype: this.order.type,
              url: 'https://www.aquaservices.no/#/customer/orders',
              supplier_company: this.order.supplier_company.name,
              customer_company: this.order.customer_company.name,
            }
          };

          if (this.order.created_email != null) {
            message.cc = this.order.created_email
          }

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        axios
          .put("https://api.eines-as.no/orders/" + order.id, order)
          .then((response) => {
            this.queryCustomer = "";

            this.isLoading = false;
          })
          .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });;
      },

      lookupSites: debounce(function () {
        // in practice this action should be debounced

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      editOrder(orderId) {
        this.$router.push("/dashboard/order-edit/" + orderId);
      },
      openModal() {
        this.getCustomers();
      },
      customFormatter(date) {
        return moment(date).format("DD.MM.YYYY");
      },
      getDates() {
        this.order.startdate = new Date();
        this.order.enddate = new Date();
        this.order.startdate.setDate(this.order.startdate.getDate() + 5);
        this.order.enddate.setDate(this.order.enddate.getDate() + 8);

        this.disabledDates = {
          to: new Date(),
        };
      },
    },
    created: function () {
      this.getUser();
      this.getOrders();
      this.getDates();
    },
  };

</script>

<style lang="css">
  .country-flag {
    max-width: 20px;
    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.9);
  }

  .background-white {
    background: #ffffff;
  }

  /*
 * Link
 */

  /* Links */

  .link {
    color: #484848;
  }

  /* unvisited link */
  .link:link {
    color: #484848 !important;
  }

  /* visited link */
  .link:visited {
    color: #484848 !important;
  }

  /* mouse over link */
  .link:hover {
    color: #6e6e6e !important;
  }

  /* selected link */
  .link:active {
    color: #484848 !important;
  }

</style>
